import { setChatListFailed, setChatListPending, setChatListSucceed } from './actions';
import { IChatListRequest } from './types';
import { transformItemListChatV1 } from '../../mappers/transformItemListChatV1';
import { fetchChats, IChatsRequest, TChatsResponse } from '../../repositories/chats/v1/chats';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { CHATS_ON_PAGE_LIMIT } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { isChatsV2Enabled } from '../../utils/isChatsV2Enabled';
import { setErrorPage } from '../errorPage';
// eslint-disable-next-line import/no-cycle
import { setRoute } from '../route';
import { getChatsV2 } from './getChatsV2';

/**
 * Получить список чатов
 */
export const getChats =
  ({ notClearCurrentOpenedChatId, timestamp }: IChatListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger, config } = context;
    const state = getState();

    const isChatsV2 = isChatsV2Enabled(config);

    if (isChatsV2) {
      dispatch(getChatsV2({ notClearCurrentOpenedChatId, timestamp }));

      return;
    }

    const {
      chatList,
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setChatListPending({ notClearCurrentOpenedChatId, timestamp }));

    const parameters: IChatsRequest = {
      limit: CHATS_ON_PAGE_LIMIT,
      timestampMs: timestamp,
      subAgentRealtyUserId,
    };

    try {
      const chatsResponse: TChatsResponse = await fetchChats({
        httpApi,
        parameters,
        config: { requestConfig: { withCredentials: true } },
      });

      if (chatsResponse.statusCode === 200) {
        const chats = chatsResponse.response.chats.map(transformItemListChatV1);
        dispatch(setChatListSucceed({ chats, isV2Version: false }));

        /**
         * Ставим активный пункт меню - сообщения
         */
        if (chatList.currentRoute !== ERoute.Messages) {
          dispatch(setRoute({ route: ERoute.Messages }));
        }
      } else {
        dispatch(setChatListFailed());
      }
    } catch (error) {
      logger.warning(error, {
        message: 'Не удалось получить список чатов',
        domain: 'src/shared/actions/chatList/getChats.ts',
      });

      if (chatList.isFirstLoad) {
        dispatch(setErrorPage());
      }

      dispatch(setChatListFailed());
    }
  };
